/**
 * Utility to test different analysis result formats.
 * Run this in the browser console to simulate both formats.
 */

// Simulated old format (object structure)
const oldFormatExample = {
  "topics": {
    "Oil Change Services": {
      "subtopics": {
        "Oil Change Coupons & Deals": [
          "coupon",
          "deal",
          "synthetic",
          "firestone",
          "change"
        ],
        "General Oil Change Service": [
          "change",
          "near",
          "firestone",
          "price",
          "service"
        ]
      }
    },
    "Oil Problems & Diagnostics": {
      "subtopics": {
        "Oil Leaks": [
          "leak",
          "repair",
          "park",
          "car",
          "near"
        ],
        "Burning Oil": [
          "burn",
          "engine",
          "car",
          "oil",
          "why"
        ]
      }
    }
  },
  "workflow_id": "test-workflow-123",
  "client_id": "test-client-456",
  "timestamp": "2025-04-24T14:22:33.701933",
  "keyword_count": 55
};

// Simulated new format (array structure with keywords)
const newFormatExample = {
  "topics": [
    {
      "name": "Oil Change Services",
      "subtopics": [
        {
          "name": "Oil Change Coupons & Deals",
          "stem_words": ["coupon", "deal", "synthetic", "firestone", "change"],
          "keywords": ["oil change coupons", "synthetic oil change deals", "firestone oil change coupon"]
        },
        {
          "name": "General Oil Change Service",
          "stem_words": ["change", "near", "firestone", "price", "service"],
          "keywords": ["oil change near me", "oil change price", "firestone oil change"]
        }
      ]
    },
    {
      "name": "Oil Problems & Diagnostics",
      "subtopics": [
        {
          "name": "Oil Leaks",
          "stem_words": ["leak", "repair", "park", "car", "near"],
          "keywords": ["car leaking oil", "oil leak repair", "car leaking oil when parked"]
        },
        {
          "name": "Burning Oil",
          "stem_words": ["burn", "engine", "car", "oil", "why"],
          "keywords": ["car burning oil", "why is my car burning oil", "engine burning oil causes"]
        }
      ]
    }
  ],
  "missing_themes": ["Tire Services", "Brake Services", "Battery Services"],
  "workflow_id": "test-workflow-123",
  "client_id": "test-client-456",
  "timestamp": "2025-04-24T14:22:33.701933",
  "keyword_count": 55
};

// This function demonstrates both formats in the AnalysisResults component
function testAnalysisFormats() {
  console.log("Use one of these examples to test the AnalysisResults component:");
  console.log("1. Old format (object structure):", oldFormatExample);
  console.log("2. New format (array structure with keywords):", newFormatExample);
  
  console.log("\nTo test in a React component:");
  console.log("1. Import the formats:");
  console.log("   import { oldFormatExample, newFormatExample } from '../utils/testAnalysisFormat';");
  console.log("2. Pass to AnalysisResults component:");
  console.log("   <AnalysisResults data={newFormatExample} workflowId=\"test-workflow-123\" />");
  
  // Return formats for direct use
  return {
    oldFormat: oldFormatExample,
    newFormat: newFormatExample
  };
}

// Export the examples and test function
export { oldFormatExample, newFormatExample, testAnalysisFormats };

// Add to window object for browser console testing
if (typeof window !== 'undefined') {
  window.testAnalysisFormats = testAnalysisFormats;
  window.oldFormatExample = oldFormatExample;
  window.newFormatExample = newFormatExample;
}
